import { Result, Spin } from 'antd';
import { lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';

const AppLayout = lazy(() => import('./pages/appLayout'));
const Overview = lazy(() => import('./pages/overview'));
const Favorite = lazy(() => import('./pages/favorite'));
const Login = lazy(() => import('./pages/login'));
const PpnLogin = lazy(() => import('./pages/ppnLogin'));
const ApplicationDetail = lazy(() => import('./pages/applicationDetail'));
const Detail = lazy(() => import('./pages/detail'));
const LogCenter = lazy(() => import('./pages/logCenter'));
const VehicleLogCenter = lazy(() => import('./pages/vehicleLogCenter'));
const MessageCenter = lazy(() => import('./pages/messageCenter'));
const AppAdmin = lazy(() => import('./pages/appAdmin'));
const PersonalInfo = lazy(() => import('./pages/personalInfo'));
const ChangePassword = lazy(() => import('./pages/changePassword'));
const CreateApp = lazy(() => import('./pages/appAdmin/createApp'));
const TagAdmin = lazy(() => import('./pages/tagAdmin'));
const FeedbackHistory = lazy(() => import('./pages/feedbackHistory'));
const RoleAdmin = lazy(() => import('./pages/roleAdmin'));
const UserAdmin = lazy(() => import('./pages/userAdmin'));
const UserGroupAdmin = lazy(() => import('./pages/userGroupAdmin'));
const DashboardConfig = lazy(() => import('./pages/dashboardConfig'));
const FeedbackCenter = lazy(() => import('./pages/feedbackCenter'));
const ChangeLog = lazy(() => import('./pages/changeLog'));
const PpnLogout = lazy(() => import('./pages/ppnLogout'));
const CdSettings = lazy(() => import('./pages/cdSettings'));
const CostSettings = lazy(() => import('./pages/costSettings'));
const CostHistory = lazy(() => import('./pages/costHistory'));
const CostDashboard = lazy(() => import('./pages/costDashboard'));
const AccountCost = lazy(() => import('./pages/costDashboard/accountCost'));
const Application = lazy(() => import('./pages/costDashboard/application'));
const AppCostAnalysis = lazy(() => import('./pages/costDashboard/appCostAnalysis'));
const ServiceConst = lazy(() => import('./pages/costDashboard/serviceCost'));
const CostCalculate = lazy(() => import('./pages/costCalculate'));
const Event = lazy(() => import('./pages/event'));
const Logging = lazy(() => import('./pages/logging'));
const ESLogging = lazy(() => import('./pages/logging/es'));
const SplunkLogging = lazy(() => import('./pages/logging/splunk'));
const CostAnalysis = lazy(() => import('./pages/costCalculate/costAnalysis'));
const AssessmentResult = lazy(() => import('./pages/costCalculate/assessmentResult'));
const AiLab = lazy(() => import('./pages/aiLab'));
const AiLabChat = lazy(() => import('./pages/aiLab/chat'));
const AiOpsChat = lazy(() => import('./pages/aiOpsChat'));
const AiOpsSetting = lazy(() => import('./pages/aiOpsSetting'));
const Test = lazy(() => import('./pages/test'));
const Test1 = lazy(() => import('./pages/test1'));
const VehicleData = lazy(() => import('./pages/vehicleData'));
const BindMFA = lazy(() => import('./pages/login/mfa'));
const ServiceContrastCost = lazy(() => import('./pages/costDashboard/serviceContrastCost'));
const CostAlertDetail = lazy(() => import('./pages/costDashboard/components/costAlertDetail'));
const Audit = lazy(() => import('./pages/audit'));
const KubectlConsole = lazy(() => import('./pages/kubectlConsole'));
const CostAlertRule = lazy(() => import('./pages/costAlertRule'));
const NotificationSettings = lazy(() => import('./pages/notificationSettings'));
const NotificationChannels = lazy(() => import('./pages/notificationChannels'));
const NotificationTemplates = lazy(() => import('./pages/notificationTemplates'));
const NotificationManagement = lazy(() => import('./pages/notificationManagement'));
const InfraMonitoring = lazy(() => import('./pages/infraMonitoring'));
const LogAlertMonitor = lazy(() => import('./pages/logAlertMonitor'));
const Mdk = lazy(() => import('./pages/monitor/mdkStatistic/mdk'));
const ReleaseNotes = lazy(() => import('./pages/releaseNotes'));
const ReleaseNoteConfig = lazy(() => import('./pages/releaseNotes/ReleaseNoteConfig'));
const FullChangelog = lazy(() => import('./pages/releaseNotes/FullChangelog'));
//避免闪屏x
const loadLazy = (children) => {
  return (
    <Suspense
      fallback={
        <div
          style={{
            textAlign: 'center',
            fontSize: '20px',
            padding: '100px 0'
          }}
        >
          <Spin />
        </div>
      }
    >
      {children}
    </Suspense>
  );
};

export const router = [
  {
    path: '/',
    element: loadLazy(<AppLayout />),
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard/overview" />
      },
      {
        path: 'dashboard',
        authority: 'DASHBOARD_VIEW',
        children: [
          {
            index: true,
            element: <Navigate to="/dashboard/overview" />
          },
          {
            path: 'overview',
            authority: 'APP_OVERVIEW',
            children: [
              {
                path: '',
                element: loadLazy(<Overview />),
                from: 'overview'
              },
              {
                path: 'applicationDetail',
                element: loadLazy(<ApplicationDetail />),
                from: 'overview'
              },
              {
                path: 'detail',
                element: loadLazy(<Detail />),
                from: 'overview'
              },
              {
                path: 'event',
                element: loadLazy(<Event />),
                from: 'overview'
              },
              {
                path: 'logging',
                element: loadLazy(<Logging />),
                from: 'overview'
              }
            ]
          },
          {
            path: 'kubectl',
            element: loadLazy(<KubectlConsole />),
            from: 'overview',
            authority: 'APP_OVERVIEW'
          },
          {
            path: 'favorite',
            authority: 'APP_OVERVIEW',
            children: [
              {
                path: '',
                element: loadLazy(<Favorite />),
                from: 'favorite'
              },
              {
                path: 'applicationDetail',
                element: loadLazy(<ApplicationDetail />),
                from: 'favorite'
              },
              {
                path: 'detail',
                element: loadLazy(<Detail />),
                from: 'favorite'
              },
              {
                path: 'event',
                element: loadLazy(<Event />),
                from: 'favorite'
              },
              {
                path: 'logging',
                element: loadLazy(<Logging />),
                from: 'favorite'
              }
            ]
          }
        ]
      },
      {
        path: 'monitor',
        authority: 'APP_MONITROING',
        children: [
          {
            index: true,
            element: <Navigate to="/monitor/logCenter" />
          },
          {
            path: 'notification',
            element: loadLazy(<MessageCenter />),
            authority: 'APP_MONITORING_VIEW'
          },
          {
            path: 'logCenter',
            element: loadLazy(<LogCenter />),
            authority: 'APP_LOG_CENTER_VIEW'
          },
          {
            path: 'logAlertMonitor',
            element: loadLazy(<LogAlertMonitor />),
            authority: 'APP_LOG_CENTER_VIEW'
          },
          {
            path: 'mdk',
            element: loadLazy(<Mdk />),
            authority: 'APP_MONITORING_VIEW'
          },
          {
            path: 'infrastructure',
            element: loadLazy(<InfraMonitoring />),
            authority: 'APP_MONITORING_VIEW'
          }
        ]
      },
      {
        path: 'infraMonitoring',
        children: [
          {
            index: true,
            element: <Navigate to="/monitor/infrastructure" />
          },
          {
            path: 'infrastructure',
            element: <Navigate to="/monitor/infrastructure" />
          }
        ]
      },
      {
          path: 'auditLog',
          element: loadLazy(<Audit />),
          authority: 'OPERATION_HISTORY'
      },
      {
        path: 'preference',
        authority: 'PREFERENCE',
        children: [
          {
            index: true,
            element: <Navigate to="/preference/tagAdmin" />
          },
          {
            path: 'tagAdmin',
            element: loadLazy(<TagAdmin />),
            authority: 'TAG_ADMIN'
          }
        ]
      },
      {
        path: 'console',
        authority: 'ADMIN_CONSOLE',
        children: [
          {
            index: true,
            element: <Navigate to="/console/appAdmin" />
          },
          {
            path: 'appAdmin',
            element: loadLazy(<AppAdmin />),
            authority: 'APP_ADMIN'
          },
          {
            path: 'createApp',
            element: loadLazy(<CreateApp />),
            from: 'appAdmin',
            authority: 'APP_ADMIN'
          },
          {
            path: 'roleAdmin',
            element: loadLazy(<RoleAdmin />),
            authority: 'ROLE_ADMIN'
          },
          {
            path: 'userAdmin',
            element: loadLazy(<UserAdmin />),
            authority: 'USER_ADMIN'
          },
          {
            path: 'userGroupAdmin',
            element: loadLazy(<UserGroupAdmin />),
            authority: 'USER_ADMIN'
          },
          {
            path: 'dashboardConfig',
            element: loadLazy(<DashboardConfig />),
            authority: 'USER_ADMIN'
          },
          {
            path: 'feedbackCenter',
            element: loadLazy(<FeedbackCenter />),
            authority: 'FEEDBACK_CENTER'
          },
          {
            path: 'cdSettings',
            element: loadLazy(<CdSettings />),
            authority: 'CD_SETTINGS'
          },
          {
            path: 'costSettings',
            element: loadLazy(<CostSettings />),
            authority: 'CD_SETTINGS'
          },
          {
            path: 'costHistory',
            element: loadLazy(<CostHistory />),
            authority: 'CD_SETTINGS'
          },
          {
            path: 'notificationManagement',
            element: loadLazy(<NotificationManagement />),
            authority: 'CD_SETTINGS'
          },
          {
            path: 'notificationSettings',
            element: loadLazy(<NotificationSettings />),
            authority: 'CD_SETTINGS'
          },
          {
            path: 'costAlertRule',
            element: loadLazy(<CostAlertRule />),
            authority: 'CD_SETTINGS'
          },
          {
            path: 'notificationChannels',
            element: loadLazy(<NotificationChannels />),
            authority: 'CD_SETTINGS'
          },
          {
            path: 'notificationTemplates',
            element: loadLazy(<NotificationTemplates />),
            authority: 'CD_SETTINGS'
          },
          {
            path: 'releaseNotes',
            children: [
              {
                index: true,
                element: loadLazy(<ReleaseNotes />),
                authority: 'ADMIN_CONSOLE'
              },
              {
                path: 'configuration',
                element: loadLazy(<ReleaseNoteConfig />),
                authority: 'ADMIN_CONSOLE'
              }
            ]
          },
          {
            path: 'aiOpsSetting',
            element: loadLazy(<AiOpsSetting />),
            authority: 'AI_OPS_SETTING'
          },
        ]
      },
      {
        path: 'finance',
        authority: 'COST_FINANCE',
        children: [
          {
            path: 'costDashboard',
            authority: 'COST_EXP_VIEW',
            children: [
              {
                index: true,
                element: loadLazy(<CostDashboard />),
                from: 'costDashboard'
              },
              {
                path: 'accountCost',
                element: loadLazy(<AccountCost />),
                from: 'costDashboard'
              },
              {
                path: 'application',
                element: loadLazy(<Application />),
                from: 'costDashboard'
              },
              {
                path: 'appCostAnalysis',
                element: loadLazy(<AppCostAnalysis />),
                from: 'costDashboard'
              },
              {
                path: 'service',
                element: loadLazy(<ServiceConst />),
                from: 'costDashboard'
              },
              {
                path: 'serviceCostContrast',
                element: loadLazy(<ServiceContrastCost />),
                from: 'costDashboard'
              },
              {
                path: 'costAlertDetail',
                element: loadLazy(<CostAlertDetail />),
                from: 'costDashboard'
              }
            ]
          },
          {
            path: 'costCalculate',
            authority: 'COST_MODEL_VIEW',
            children: [
              {
                index: true,
                element: loadLazy(<CostCalculate />),
                from: 'costCalculate'
              },
              {
                path: 'costAnalysis',
                element: loadLazy(<CostAnalysis />),
                from: 'costCalculate'
              },
              {
                path: 'assessmentResult',
                element: loadLazy(<AssessmentResult />),
                from: 'costCalculate'
              }
            ]
          }
        ]
      },
      {
        path: 'experimental',
        children: [
          {
            path: 'aiLab',
            children: [
              {
                index: true,
                element: loadLazy(<AiLab />),
                from: 'aiLab'
              },
              {
                path: 'chat',
                element: loadLazy(<AiLabChat />),
                from: 'aiLab'
              }
            ]
          },
          {
            path: 'aiOps',
            children: [
              {
                path: 'chat',
                authority: 'AI_OPS_CHAT_WINDOW',
                element: loadLazy(<AiOpsChat />),
                from: 'aiOps'
              }
            ]
          }
        ]
      },
      {
        path: 'vehicle',
        authority: 'VEHICLE_LOG',
        children: [
          {
            path: 'tools',
            element: <Navigate to="/vehicle/vehicleData" replace />,
          },
          {
            path: 'vehicleData',
            element: loadLazy(<VehicleData />),
            from: 'vehicleData'
          },
          {
            path: 'logCenter',
            element: loadLazy(<VehicleLogCenter />),
            from: 'vehicleLogCenter'
          },
        ]
      },
      {
        path: 'personalInfo',
        element: loadLazy(<PersonalInfo />)
      },
      {
        path: 'changePassword',
        element: loadLazy(<ChangePassword />)
      },
      {
        path: 'changeLog',
        element: loadLazy(<ChangeLog />)
      },
      {
        // 预览态 changelog：管理页 Preview → View All Updates 专用，
        // 与用户真实页面 /changeLog 隔离；预览数据存 store（刷新即失，回退到普通列表）
        path: 'changeLog/preview',
        element: loadLazy(<ChangeLog />)
      },
      {
        path: 'releaseNotes/changelog',
        element: loadLazy(<FullChangelog />)
      },
      {
        path: 'messageCenter',
        element: loadLazy(<MessageCenter />)
      },
      {
        path: 'feedbackHistory',
        element: loadLazy(<FeedbackHistory />)
      },
      {
        path: 'test',
        element: loadLazy(<Test />)
      },
      {
        path: 'test1',
        element: loadLazy(<Test1 />)
      },
      {
        path: '*',
        element: (
          <Result
            status="404"
            title="404"
            subTitle="Sorry, the page you visited does not exist."
          />
        ),
        authority: 'page404'
      }
    ]
  },
  {
    path: 'ppnLogin',
    element: loadLazy(<PpnLogin />)
  },
  {
    path: 'ppnLogout',
    element: loadLazy(<PpnLogout />)
  },
  {
    path: 'login',
    element: loadLazy(<Login />)
  },
  {
    path: 'bindMfa',
    element: loadLazy(<BindMFA />)
  },
  {
    path: '*',
    // element: <Navigate to="/" />
    element: (
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        // extra={<Button type="primary">Back Home</Button>}
      />
    ),
    authority: 'page404'
  }
];
